export interface MediaDetailCaptionEditorProps {
  caption?: string;
  isEditing: boolean;
  value: string;
  isLoading: boolean;
  onChange: (value: string) => void;
  onStartEdit: () => void;
  onSave: () => void;
  onCancel: () => void;
}

export const MediaDetailCaptionEditor = ({
  caption,
  isEditing,
  value,
  isLoading,
  onChange,
  onStartEdit,
  onSave,
  onCancel,
}: MediaDetailCaptionEditorProps) => (
  <div>
    <div className="flex items-center justify-between mb-2">
      <span className="text-sm font-medium text-gray-700">Caption</span>
      {!isEditing && (
        <button onClick={onStartEdit} className="text-xs text-primary-600 hover:text-primary-700">
          Edit
        </button>
      )}
    </div>
    {isEditing ? (
      <div className="space-y-2">
        <textarea
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Add a caption..."
          rows={3}
          className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-info-500 focus:border-info-500"
        />
        <div className="flex space-x-2">
          <button
            onClick={onSave}
            disabled={isLoading}
            className="px-3 py-1 text-xs font-medium text-white bg-primary-600 rounded hover:bg-primary-700 disabled:opacity-50"
          >
            Save
          </button>
          <button
            onClick={onCancel}
            disabled={isLoading}
            className="px-3 py-1 text-xs font-medium text-gray-700 bg-gray-100 rounded hover:bg-gray-200 disabled:opacity-50"
          >
            Cancel
          </button>
        </div>
      </div>
    ) : (
      <p className="text-sm text-gray-600">{caption || 'No caption'}</p>
    )}
  </div>
);
